import { useEffect } from "react";

/**
 * What the current screen is showing, for pin feedback: a board reports its id, filters and sprint; a backlog its board and
 * search. A plain module-level store (the same pattern as shared/lib/activeProject.ts), so a deeply nested screen can
 * report without threading props, and the Feedback popover reads it only when a report is filed (no re-renders).
 */
let current: Record<string, unknown> | undefined;
let owner: symbol | undefined;

export function getFeedbackPageState(): Record<string, unknown> | undefined {
  return current;
}

/** Reports `state` while mounted (re-reported whenever its JSON changes); clears only its own report on unmount. */
export function useReportFeedbackContext(state: Record<string, unknown> | undefined): void {
  const serialized = state === undefined ? undefined : safeJson(state);
  useEffect(() => {
    if (serialized === undefined) return;
    const token = Symbol("feedback-context");
    owner = token;
    current = JSON.parse(serialized) as Record<string, unknown>;
    return () => {
      if (owner === token) {
        owner = undefined;
        current = undefined;
      }
    };
  }, [serialized]);
}

function safeJson(value: unknown): string | undefined {
  try {
    return JSON.stringify(value);
  } catch {
    return undefined;
  }
}
